import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { Box, Button, Flex, Text } from "pcln-design-system";
import { useContext, useEffect, useRef, useState } from "react";
import { ChatbotDataContext } from "../../context/ChatbotDataContext.js";
import { OtpContextProvider } from "../../context/OtpContext.js";
import { useChatMessagesContext } from "../../hooks/useChatMessagesContext.js";
import { TravelBotLogoImage } from "../../TravelBotLogoImage.js";
import { getLastUserMessageContent } from "../../utils/getLastUserMessage.js";
import sanitizeInput from "../../utils/sanitizeInput.js";
import { ChatMessage } from "../CustomChatMessage/index.js";
import FindMyTrips from "../FindMyTrips/FindMyTrips.js";
import MessageFooter from "../MessageFooter/MessageFooter.js";
import PennyChatBubble from "../PennyChatBubble/index.js";
const SignOutActions = ({ message, submitMessagesFn, showOtpForm, displayHardCodedMessage = true })=>{
    const { chatMessages } = useChatMessagesContext();
    const { setiValues } = useContext(ChatbotDataContext);
    const [showTripForm, setShowTripForm] = useState(false);
    const messageEndRef = useRef(null);
    const lastuserQuestion = getLastUserMessageContent(chatMessages);
    const encodedLastUserQuestion = `?openPenny=y${encodeURIComponent('&')}askPrompt=${sanitizeInput(lastuserQuestion)}`;
    const currentPathName = 'undefined' != typeof window ? window.location.pathname : '/';
    const signOutActionButtons = [
        {
            name: 'Sign In',
            link: ()=>{
                window.location.href = `/home/join?flow=authenticate&redirecturl=${currentPathName}${encodedLastUserQuestion}`;
            }
        },
        {
            name: 'Find My Trip',
            link: ()=>{
                window.open('/next-profile/trip-lookup');
            }
        }
    ];
    function handleOtpSubmit(token) {
        submitMessagesFn({
            role: 'assistant',
            content: 'User is trying to access their bookings'
        }, null, {
            'account-less-access-token': token
        });
    }
    useEffect(()=>{
        messageEndRef.current?.scrollIntoView({
            behavior: 'smooth'
        });
    }, [
        showOtpForm,
        showTripForm
    ]);
    const content = /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsx(Text, {
                mb: 3,
                children: "To access your trips, please sign in to your account. Alternatively we can find your trip by providing us some details."
            }),
            /*#__PURE__*/ jsx(Text, {
                children: "To safeguard your privacy, this chat will be cleared upon signing in."
            })
        ]
    });
    return /*#__PURE__*/ jsxs(Box, {
        children: [
            /*#__PURE__*/ jsxs(Flex, {
                flexDirection: "column",
                children: [
                    displayHardCodedMessage && (setiValues?.shouldEnablePortalUpdates ? /*#__PURE__*/ jsx(PennyChatBubble, {
                        message: message,
                        children: content
                    }) : /*#__PURE__*/ jsx(ChatMessage, {
                        ml: "",
                        mb: "20px",
                        variation: 'initial',
                        Icon: TravelBotLogoImage,
                        message: content,
                        footer: /*#__PURE__*/ jsx(MessageFooter, {})
                    })),
                    /*#__PURE__*/ jsx(Flex, {
                        ml: 3,
                        children: signOutActionButtons.map((actionBtns)=>/*#__PURE__*/ jsx(Button, {
                                mr: 2,
                                onClick: function() {
                                    if ('Find My Trip' === actionBtns.name && showOtpForm) setShowTripForm(true);
                                    else actionBtns.link();
                                },
                                variation: "subtle",
                                children: actionBtns.name
                            }, actionBtns.name))
                    })
                ]
            }),
            showTripForm ? /*#__PURE__*/ jsx(OtpContextProvider, {
                handleOtpSubmit: handleOtpSubmit,
                children: /*#__PURE__*/ jsx(FindMyTrips, {
                    message: message
                })
            }) : null,
            /*#__PURE__*/ jsx(Box, {
                ref: messageEndRef
            })
        ]
    });
};
const SignOutActions_SignOutActions = SignOutActions;
export { SignOutActions_SignOutActions as default };
